import styled from 'styled-components';
import { COLORS, DEVICES, FONT_FAMILY } from '@Commons';

export const formatPadding = (padding: Array<number>): string => {
  if (padding.length === 2) {
    return `${padding[0]}px ${padding[1]}px`;
  } else if (padding.length === 4) {
    return `${padding[0]}px ${padding[1]}px ${padding[2]}px ${padding[3]}px`;
  } else {
    return `0`;
  }
};

type FormContainerProps = {
  marginTop?: number;
  margin?: number;
};

export const FormContainer = styled.div<FormContainerProps>`
  margin-top: ${(props) => props.marginTop}px;
  margin: ${(props) => props.margin}px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  .kycInfo {
    justify-content: center;
  }
`;

type RowProps = {
  padding: Array<number>;
  shouldHide?: boolean;
  flexDirection?: string;
};

export const Row = styled.div<RowProps>`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: ${({ flexDirection }) => (flexDirection ? 'row' : 'column')};
  padding: ${({ padding }) => formatPadding(padding)};
  display: ${({ shouldHide }) => (!shouldHide ? 'flex' : 'none')};
  @media ${DEVICES.mobileS} {
    flex-direction: column;
  }
`;

type ColProps = {
  width: number;
  isHalfColumn?: boolean;
};

export const Col = styled.div<ColProps>`
  width: ${(props: any) => props.width}px;

  div[class*='makeStyles-formControl'] {
    margin: 0 !important;
  }
  div[class*='jss'] {
    margin: 0 !important;
  }

  .MuiInputBase-root,
  [class*='outlinedDropdownField__OutlinedDropdown'] {
    width: ${({ isHalfColumn }) => (isHalfColumn ? '100%' : '450px')} !important;
  }
  label.label-color,
  label.MuiFormLabel-root {
    font-size: 16px !important;
    line-height: 17px !important;
  }
  label.Mui-error {
    color: ${COLORS.newerror} !important;
  }
  label.Mui-focused {
    margin-top: -3px !important;
  }
  .MuiFormControl-root {
    height: 50px;
    margin-bottom: 0;
  }
  div.Mui-focused {
    outline: none !important;
    border: none !important;
  }
  margin: 0;
  .div-160 {
    width: 160px !important;
  }

  .addressErrorMsg {
    color: red;
  }

  .input-error-wrapper {
    div {
      height: auto;
      margin-bottom: 0;
    }
    #issuing-country {
      width: 100%;
    }
    span {
      margin-bottom: 0;
    }
  }

  span.error-msg {
    margin-top: 5px;
    color: ${COLORS.newerror};
    font-size: 12px;
  }
  .form-text-field,
  .input.form-flow {
    width: 100%;
    .input {
      width: 100%;
    }
    label {
      background-color: ${COLORS.white};
      padding: 0 5px;
      margin: -14px 10px;
    }
    input {
      width: 100%;
      height: 50px;
      border: 1px solid ${COLORS.textDarkGray};
      border-radius: 3px;
      &:focus {
        border: 1px solid ${COLORS.black};
        border-radius: 3px;
      }
      &:hover {
        border: 1px solid ${COLORS.black};
        border-radius: 3px;
      }
    }
  }
  .date-picker-label {
    margin: -8px 10px;
    padding: 0 5px;
    background: ${COLORS.white};
  }
  .react-datepicker-wrapper {
    border: 1px solid ${COLORS.textDarkGray};
    border-radius: 3px;
    .react-datepicker__input-container {
      padding: 15px 10px !important;
      border: none !important;
    }
  }

  @media ${DEVICES.mobileXL} {
    width: 400px !important;
    .MuiInputBase-root,
    [class*='outlinedDropdownField__OutlinedDropdown'] {
      width: 400px !important;
    }
  }
  @media ${DEVICES.mobileL} {
    width: 350px !important;
    .MuiInputBase-root,
    [class*='outlinedDropdownField__OutlinedDropdown'] {
      width: 350px !important;
    }
  }
  @media ${DEVICES.mobileM} {
    width: 300px !important;
    .MuiInputBase-root,
    [class*='outlinedDropdownField__OutlinedDropdown'] {
      width: 300px !important;
    }
  }
  @media ${DEVICES.mobileS} {
    width: 250px !important;
    .MuiInputBase-root,
    [class*='outlinedDropdownField__OutlinedDropdown'] {
      width: 250px !important;
    }
  }
`;

type ParentContainerProps = {
  padding: Array<number>;
  headingDescWidth?: number;
};

export const ParentContainer = styled.div<ParentContainerProps>`
  padding: ${({ padding }) => formatPadding(padding)};
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;

  input[type='file'] {
    opacity: 0 !important;
    position: absolute !important;
  }
  input {
    &:focus {
      font-family: ${FONT_FAMILY.hellix.regular} !important;
    }
    &:not(:placeholder-shown):not(:focus) {
      border-color: ${COLORS.borderGrey};
      font-family: ${FONT_FAMILY.hellix.regular} !important;
    }
    ::-webkit-input-placeholder {
      /* Chrome/Opera/Safari */
      color: ${COLORS.disabled} !important;
      text-transform: none !important;
    }
    ::-moz-placeholder {
      /* Firefox 19+ */
      color: ${COLORS.disabled} !important;
      text-transform: none !important;
    }
    :-ms-input-placeholder {
      /* IE 10+ */
      color: ${COLORS.disabled} !important;
      text-transform: none !important;
    }
    :-moz-placeholder {
      /* Firefox 18- */
      color: ${COLORS.disabled} !important;
      text-transform: none !important;
    }
  }
  .navigationContainer {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    width: 100%;
    align-items: center;
    justify-content: center;
    z-index: 2;

    .backButton {
      grid-column: 1;
      cursor: pointer;
    }
    .closeButton {
      grid-column: 3;
      cursor: pointer;
    }
    * {
      justify-self: center;
    }
    @media ${DEVICES.mobileXL} {
      margin-top: 8px;

      .closeButton {
        justify-self: right;
        margin-right: 15px;
      }
    }
  }

  @media ${DEVICES.mobileXL} {
    width: 100%;
    margin: 0;
    padding: ${({ padding }) => formatPadding(padding)};
  }

  .notes-field-tooltip {
    height: 24px;
    width: 24px;
  }
`;

export const PoweredByLogoWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 48px;
`;

export const PDFContainer = styled.div`
  border: 2px solid black;
`;

export const EmptyPDFContainer = styled.div`
  height: 200px !important;
`;

type DisclaimerInfoType = {
  margin: Array<number>;
};
export const DisclaimerInfo = styled.div<DisclaimerInfoType>`
  display: flex;
  padding: 12px 16px;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
  border-radius: 8px;
  border: ${COLORS.lightBlueDark};
  background: ${COLORS.lightBlueBackground};
  margin: ${({ margin }) => formatPadding(margin)};
  .disclaimerInfo {
    display: flex;
    flex-direction: column;
  }
  .image {
    font-size: 14px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    img {
      margin-right: 12px;
    }
  }
  .info {
    font-family: ${FONT_FAMILY.hellix.regular};
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    color: ${COLORS.textGrey};
    .bold {
      font-weight: 700 !important;
      font-family: ${FONT_FAMILY.hellix.bold};
    }
  }
  .vkyc-info {
    margin-bottom: 20px;
  }
`;
